/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');
var momentUtil = require('common/util/momentUtil');

module.exports = function(complianceId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetComplianceAGReferralPaymentsByCompliance: {
        $xmlns: 'http://dobs.pa.gov/sc/compliance/bpm/1.0',
        ComplianceID: complianceId
      }
    },
    blueprintArrays: ['GetComplianceAGReferralPaymentsByComplianceResponse.AGPayments.SC_ComplianceAGReferralPayment'],
    blueprint: {
      complianceId: '$..ID',
      AGReferralDate: '$..AGReferralDate',
      AGReferredAmount: '$..AGReferredAmount',
      AGPayments: [
        '$..SC_ComplianceAGReferralPayment',
        {
          AGPaymentId: '$..ID',
          paymentDate: '$..PaymentDate',
          amount: '$..Amount',
          checkNumber: '$..CheckNumber',
          transactionNumber: '$..TransactionNumber'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      var formInboundDateConfig = {
        sourceFormat: 'YYYY-MM-DD',
        targetFormat: 'MM/DD/YYYY',
        default: undefined
      };

      response.AGReferralDate = momentUtil.formatStr(response.AGReferralDate, formInboundDateConfig);

      _.each(response.AGPayments, function(AGPayment) {
        AGPayment.paymentDateDisplay = AGPayment.paymentDate || '--';
        AGPayment.paymentDate = momentUtil.formatStr(AGPayment.paymentDate, formInboundDateConfig);

        AGPayment.checkNumberDisplay = AGPayment.checkNumber || '--';
        AGPayment.transactionNumberDisplay = AGPayment.transactionNumber || '--';
      });
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
